//@ts-nocheck
import {
  point,
  polygon,
  // multiPolygon,
} from '@turf/helpers'
import {coordEach} from '@turf/meta';
import circle from '@turf/circle';
// import {lineEach} from '@turf/meta';
// import computeDistance from '@turf/distance';
// import polygonClipping from 'polygon-clipping'
// import { offsetSegment, roundJoin, angle } from './buffer-utils'
import {polygonHull} from 'd3-polygon';
import lineSegment from '@turf/line-segment'
import union from '@turf/union';
// import explode from '@turf/explode';
// import concave from '@turf/concave';
// import concave from 'concaveman';

function bufferPoint(geometry, distance, steps) {
  if (distance < 0) {
    return polygon([])
  }

  return circle(geometry, distance, {
    // We use 4x steps because we treat point as 360 angle
    steps: steps * 4,
    units: 'miles'
  })
}

// function eachAngle(segment, isPolygon, callback) {
//   for (let i = 0; i < segment.length - 2; i++) {
//     callback([segment[i], segment[i + 1], segment[i + 2]])
//   }
//
//   if (isPolygon) {
//     callback([
//       segment[segment.length - 2],
//       segment[segment.length - 1],
//       segment[1]
//     ])
//   } else {
//     callback([segment[1], segment[0], segment[1]])
//     callback([
//       segment[segment.length - 2],
//       segment[segment.length - 1],
//       segment[segment.length - 2]
//     ])
//   }
// }

function bufferCircle(geometry, distance, steps) {
  let polygons = [];
  let a, b;
  const segments = lineSegment(geometry);
  let i = -1;
  while (++i < segments.features.length) {
    const feature = segments.features[i];
    const localCoords: number[][] = [];
    a = (bufferPoint(point(feature.geometry.coordinates[0]), distance, steps));
    b = (bufferPoint(point(feature.geometry.coordinates[1]), distance, steps));
    coordEach(a,
        function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
          localCoords.push(currentCoord);
        });

    coordEach(b,
        function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
          localCoords.push(currentCoord);
        });

    const p = polygonHull(localCoords);
    p.push(p[0]);
    polygons.push(polygon([p]));
  }
  let unioned = polygons.pop();
  while(polygons.length > 0) {
    unioned = union(unioned, polygons.pop())
  }
  if (geometry.type === 'LineString') {
    return unioned;
  } else {
    unioned = union(unioned, {type: 'Feature', geometry});
    return unioned;
    // const points = explode(unioned) as any;
    // return concave(points);
    // const u = union(...polygons);
    // return hull;
  }
}

// function bufferCircle2(geometry, distance, steps) {
//   const coords = [];
//   coordEach(geometry,
//       function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
//       const b = (bufferPoint(point(currentCoord), distance, steps));
//       coordEach(b,
//       function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
//         coords.push(currentCoord);
//       });
//   });
//   const d = polygonHull(coords)
//   d.push(d[0]);
//   return polygon([d]);
// }
//
// function buffer(geometry, distance, steps, endType?, joinType?) {
//   const isPolygon =
//     geometry.type === 'Polygon' || geometry.type === 'MultiPolygon'
//
//   if (!isPolygon && distance <= 0) {
//     return polygon([])
//   }
//
//   const parts = []
//
//   const createJoin = roundJoin
//
//   const absdistance = Math.abs(distance)
//   lineEach(geometry, function(segment) {
//     const coords = segment.geometry.coordinates
//
//     eachAngle(coords, isPolygon, function(angle) {
//       parts.push(processAngle(angle, absdistance, steps, createJoin))
//     })
//   })
//
//   let result = polygonClipping.union(parts)
//
//   if (distance >= 0) {
//     if (isPolygon) {
//       result = polygonClipping.union(geometry.coordinates, result)
//     }
//   } else {
//     result = polygonClipping.difference(geometry.coordinates, result)
//   }
//
//   if (!result || !result[0] || typeof result[0][0][0] === 'number') {
//     return polygon(result)
//   } else {
//     return multiPolygon(result)
//   }
// }

// function processAngle(coords, distance, steps, createJoin) {
//   const firstin = offsetSegment(coords[1], coords[0], distance)
//   const firstout = offsetSegment(coords[1], coords[0], -distance)
//   const angleInRads = angle(coords[2], coords[1], coords[0])
//   const angleSteps = Math.max(
//     1,
//     Math.round(steps * Math.abs(angleInRads / Math.PI - 1) * 2)
//   )
//
//   if (angleInRads < Math.PI) {
//     const secondin = offsetSegment(coords[1], coords[2], distance)
//
//     return [
//       [coords[1], firstin[0], firstin[1], firstout[1]].concat(
//         createJoin(coords[1], distance, firstout[0], secondin[0], angleSteps),
//         [coords[1]]
//       )
//     ]
//   } else {
//     const secondout = offsetSegment(coords[1], coords[2], -distance)
//
//     return [
//       [coords[1]].concat(
//         createJoin(coords[1], distance, secondout[0], firstin[0], angleSteps),
//         [firstin[1], firstout[1], firstout[0], coords[1]]
//       )
//     ]
//   }
// }

export function bufferGeoJSON(geojson, distance, units, steps) {
  if (!geojson) throw new Error('geojson-buffer: Feature is required')

  if (distance === undefined || distance === null || isNaN(distance))
    throw new Error('dgeojson-buffer: Distance is required')

  const geometry = geojson.type === 'Feature' ? geojson.geometry : geojson

  const numSteps = steps || 8
  const properties = geojson.properties || {}
  // const precision = 1000000;
  let distanceDegrees = distance + 0.0000000000001; //lengthToDegrees(distance, units)
  // const pt1 = point([1,1]);
  // const circle = bufferPoint(pt1, distanceDegrees, numSteps);
  // const adjustedDistanceDegrees = computeDistance(
  //     pt1, point(circle.geometry.coordinates[0][0]), {units: 'degrees'});
  // adjust for error
  // const adjustedDistanceDegrees = distanceDegrees * 1.017;
  let buffered;

  switch (geometry.type) {
    case 'Polygon':
    case 'MultiPolygon':
    case 'LineString':
    case 'MultiLineString':
      // distanceDegrees = ((precision * distanceDegrees) | 0) / precision;
      buffered = bufferCircle(geometry, distanceDegrees, numSteps)
      break
    case 'Point':
      buffered = bufferPoint(geometry, distanceDegrees, numSteps)
      break
  }

  buffered.properties = properties

  return buffered
}
